import { useContext } from 'react';
import SEOContext from '~/context/srp/SEOContext';
import { formatKeyWordAndLocation } from './utils';

export default function TitleTag() {
  const { vanityUrl } = useContext(SEOContext);

  return vanityUrl == null ? null : (
    <h1 className="m-0 tl-label-s truncate w-full">
      {formatKeyWordAndLocation(vanityUrl)}
    </h1>
  );
}
